import { Directive, OnDestroy } from '@angular/core';
import { MonoTypeOperatorFunction, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
export abstract class BaseComponent implements OnDestroy {
  private unsubscribeSubject: Subject<void> = new Subject();

  ngOnDestroy() {
    this.onDestroy();
  }

  protected onDestroy() {
    this.unsubscribeSubject.next();
    this.unsubscribeSubject.complete();
  }

  protected autoDispose<T>(): MonoTypeOperatorFunction<T> {
    return takeUntil(this.unsubscribeSubject);
  }
}
